import { server } from "./index";

let orderApi = {
  get(id) {
    return server.get(`/order/${id}`);
  },
};

export { orderApi };
